import catalogueModalHtml from './catalogue-modal.js';

const initPageTransitions = () => {

    if (!document.getElementById('page-loader')) {
        const loader = document.createElement('div');
        loader.id = 'page-loader';
        document.body.appendChild(loader);
    }

    const loader = document.getElementById('page-loader');


    document.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (
            link &&
            link.href &&
            link.href.startsWith(window.location.origin) &&
            !link.getAttribute('target') &&
            !link.getAttribute('download') &&
            !link.href.includes('#')
        ) {
            e.preventDefault();
            const targetUrl = link.href;


            loader.classList.add('animate');

            setTimeout(() => {
                window.location.href = targetUrl;
            }, 300);
        }
    });


    window.addEventListener('pageshow', (event) => {
        if (event.persisted && loader) {
            loader.classList.remove('animate');
        }
    });
};


// Popup asking for details + an email verification code. download.html has the markup
// in the page; other pages with catalogue buttons get it added on first use.
// Calls onVerified(link) once the server has unlocked the catalogues.
const createCatalogueGate = (onVerified) => {
    if (!document.getElementById('catalogue-modal')) {
        document.body.insertAdjacentHTML('beforeend', catalogueModalHtml);
        if (window.lucide) window.lucide.createIcons();
    }

    const modal = document.getElementById('catalogue-modal');
    const form = document.getElementById('catalogue-form');
    const sendBtn = document.getElementById('catalogue-send-code');
    const submitBtn = document.getElementById('catalogue-submit');
    const submitLabel = document.getElementById('catalogue-submit-label');
    const codeInput = document.getElementById('catalogue-code');
    const statusEl = document.getElementById('catalogue-status');
    const selectedEl = document.getElementById('catalogue-selected');
    const sendLabel = sendBtn.textContent.trim();
    const submitText = submitLabel.textContent.trim();

    let pendingLink = null;
    let codeSentTo = '';
    let cooldownTimer = null;
    let busy = false;

    const STATUS_STYLES = {
        error: ['bg-red-50', 'border-red-200', 'text-red-700'],
        success: ['bg-primary-light', 'border-primary/20', 'text-primary-dark'],
    };

    const setStatus = (message, type = 'success') => {
        statusEl.textContent = message || '';
        statusEl.classList.toggle('hidden', !message);
        Object.entries(STATUS_STYLES).forEach(([key, classes]) => {
            classes.forEach((c) => statusEl.classList.toggle(c, key === type));
        });
    };

    const updateSubmit = () => {
        submitBtn.disabled = busy || !codeSentTo || !/^\d{6}$/.test(codeInput.value);
    };

    const resetCode = () => {
        codeSentTo = '';
        codeInput.value = '';
        codeInput.disabled = true;
        updateSubmit();
    };

    const startCooldown = (seconds) => {
        clearInterval(cooldownTimer);
        let left = seconds;
        sendBtn.disabled = true;
        const tick = () => {
            if (left <= 0) {
                clearInterval(cooldownTimer);
                sendBtn.disabled = false;
                sendBtn.textContent = codeSentTo ? 'Resend Code' : sendLabel;
                return;
            }
            sendBtn.textContent = `Resend in ${left}s`;
            left -= 1;
        };
        tick();
        cooldownTimer = setInterval(tick, 1000);
    };

    const catalogueName = (link) => {
        const card = link && link.closest('.product-card');
        const title = card && card.querySelector('h4');
        return title ? title.textContent.trim() : (link ? `${link.dataset.catalogue}.pdf` : '');
    };

    const openModal = (link) => {
        pendingLink = link;
        const name = catalogueName(link);
        selectedEl.textContent = name ? `Selected: ${name}` : '';
        selectedEl.classList.toggle('hidden', !name);
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        document.body.style.overflow = 'hidden';
        setTimeout(() => form.elements.name.focus(), 50);
    };

    const closeModal = () => {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        document.body.style.overflow = '';
    };

    // POSTs to a PHP endpoint and always resolves to { ok, status, message, ... }
    const post = async (url, body) => {
        let response;
        try {
            response = await fetch(url, { method: 'POST', body, credentials: 'same-origin' });
        } catch (e) {
            return { ok: false, status: 0, message: 'Network error. Please check your connection and try again.' };
        }
        try {
            const data = await response.json();
            return { ...data, status: response.status };
        } catch (e) {
            console.error(`${url} returned HTTP ${response.status} without JSON. Is PHP running on this server?`);
            const message = response.status === 404
                ? 'The verification service could not be reached. Please try again later.'
                : `Server error (${response.status}). Please try again later.`;
            return { ok: false, status: response.status, message };
        }
    };

    const validFields = () => {
        const fields = ['name', 'phone', 'email', 'company'].map((n) => form.elements[n]);
        const invalid = fields.find((f) => !f.value.trim() || !f.checkValidity());
        if (invalid) {
            setStatus('Please fill in all the fields with valid details.', 'error');
            invalid.focus();
            return false;
        }
        if (!/^\+?[0-9 ()-]{7,20}$/.test(form.elements.phone.value.trim())) {
            setStatus('Please enter a valid phone number.', 'error');
            form.elements.phone.focus();
            return false;
        }
        return true;
    };

    modal.addEventListener('click', (e) => {
        if (e.target === modal || e.target.closest('[data-catalogue-close]')) closeModal();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeModal();
    });

    // A code only works for the address it was sent to
    form.elements.email.addEventListener('input', () => {
        if (codeSentTo && form.elements.email.value.trim().toLowerCase() !== codeSentTo) {
            resetCode();
            setStatus('Email changed. Please request a new code.', 'error');
        }
    });

    codeInput.addEventListener('input', () => {
        codeInput.value = codeInput.value.replace(/\D/g, '').slice(0, 6);
        updateSubmit();
    });

    sendBtn.addEventListener('click', async () => {
        if (!validFields()) return;

        sendBtn.disabled = true;
        sendBtn.textContent = 'Sending...';
        setStatus('');

        const data = await post('/api/send-code.php', new FormData(form));
        if (data.ok) {
            codeSentTo = form.elements.email.value.trim().toLowerCase();
            codeInput.disabled = false;
            codeInput.focus();
            setStatus(`${data.message} Enter it above to unlock the download.`);
            startCooldown(data.cooldown || 60);
        } else {
            setStatus(data.message, 'error');
            if (data.retry_after) {
                startCooldown(data.retry_after);
            } else {
                sendBtn.disabled = false;
                sendBtn.textContent = codeSentTo ? 'Resend Code' : sendLabel;
            }
        }
        updateSubmit();
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (submitBtn.disabled || !validFields()) return;

        const formData = new FormData(form);
        formData.append('catalogue', catalogueName(pendingLink));
        formData.append('page', window.location.href);

        busy = true;
        updateSubmit();
        submitLabel.textContent = 'Verifying...';

        const data = await post('/api/verify-code.php', formData);
        if (data.ok) {
            setStatus(data.message);
            closeModal();
            if (pendingLink) onVerified(pendingLink);
            pendingLink = null;
        } else {
            setStatus(data.message, 'error');
            // Expired, locked out or no code on the server: a new code is needed
            if ([400, 410, 429].includes(data.status)) resetCode();
        }

        busy = false;
        submitLabel.textContent = submitText;
        updateSubmit();
    });

    return { open: openModal };
};


// Catalogue buttons carry data-catalogue="<file id>" instead of a PDF path. Clicking one
// opens the verification popup; once verified, the PDF is fetched from /api/catalogue.php,
// which only serves it to visitors with the server's signed access cookie.
const initCatalogueDownloads = () => {
    // Remembers that this browser verified, so the popup is skipped next time.
    // Only a hint for the UI: the server still checks its own cookie on every download.
    const VERIFIED_KEY = 'cpCatalogueVerified';
    let gate = null;

    const isVerified = () => {
        try { return localStorage.getItem(VERIFIED_KEY) === '1'; } catch (e) { return false; }
    };

    const setVerified = (on) => {
        try {
            if (on) localStorage.setItem(VERIFIED_KEY, '1');
            else localStorage.removeItem(VERIFIED_KEY);
        } catch (e) { /* private mode */ }
    };

    const openGate = (link) => {
        gate = gate || createCatalogueGate((verifiedLink) => {
            setVerified(true);
            start(verifiedLink, true);
        });
        gate.open(link);
    };

    const setLoading = (on) => {
        const loader = document.getElementById('page-loader');
        if (!loader) return;
        if (on) loader.classList.add('animate');
        else setTimeout(() => loader.classList.remove('animate'), 500);
    };

    const catalogueUrl = (id, dl = false) => `/api/catalogue.php?id=${encodeURIComponent(id)}${dl ? '&dl=1' : ''}`;

    // Resolves to 'ok', 'locked' (not verified yet) or 'error'
    const checkAccess = async (id) => {
        setLoading(true);
        try {
            const response = await fetch(catalogueUrl(id), { method: 'HEAD', credentials: 'same-origin', cache: 'no-store' });
            if (response.status === 403) return 'locked';
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return 'ok';
        } catch (error) {
            console.error(`Catalogue check failed (${id}):`, error);
            return 'error';
        } finally {
            setLoading(false);
        }
    };

    // Full-screen viewer: shows the PDF in the browser's own viewer, with a Download button.
    // Phones and browsers without a built-in PDF viewer get "Open" / "Download" buttons instead.
    let viewer = null;
    const getViewer = () => {
        if (viewer) return viewer;
        document.body.insertAdjacentHTML('beforeend', `
<div id="catalogue-viewer" class="fixed inset-0 z-[210] hidden flex-col bg-[#0f172a]/80 backdrop-blur-sm p-0 md:p-6"
    role="dialog" aria-modal="true" aria-labelledby="catalogue-viewer-title">
    <div class="flex flex-col w-full max-w-6xl h-full mx-auto bg-white md:rounded-xl overflow-hidden shadow-2xl">
        <div class="flex items-center gap-3 px-4 md:px-6 py-3 border-b border-slate-100">
            <i data-lucide="file-text" class="w-5 h-5 text-primary shrink-0"></i>
            <h2 id="catalogue-viewer-title" class="flex-1 min-w-0 truncate text-[15px] md:text-[17px] font-semibold text-[#1a1a1a]"></h2>
            <a id="catalogue-viewer-download" download
                class="flex items-center gap-2 bg-primary text-white font-bold text-[12px] tracking-wider uppercase px-4 py-2.5 rounded-md hover:bg-primary-dark transition-colors shrink-0">
                <i data-lucide="download" class="w-4 h-4"></i>
                <span class="hidden sm:inline">Download</span>
            </a>
            <button type="button" data-viewer-close aria-label="Close"
                class="p-2 rounded-full text-[#718096] hover:text-[#1a1a1a] hover:bg-slate-100 transition-colors shrink-0">
                <i data-lucide="x" class="w-5 h-5"></i>
            </button>
        </div>
        <iframe id="catalogue-viewer-frame" title="Catalogue preview" class="hidden flex-1 w-full bg-slate-100"></iframe>
        <div id="catalogue-viewer-fallback" class="hidden flex-1 flex-col items-center justify-center gap-6 px-6 text-center">
            <div class="w-16 h-16 rounded-full bg-primary-light flex items-center justify-center">
                <i data-lucide="file-text" class="w-8 h-8 text-primary"></i>
            </div>
            <p class="text-[#4A5568] text-[15px] max-w-sm">Your catalogue is ready. Open it to view, or download a copy.</p>
            <div class="flex flex-col sm:flex-row gap-3 w-full max-w-sm">
                <a id="catalogue-viewer-open" target="_blank" rel="noopener"
                    class="flex-1 bg-primary text-white font-bold text-[12px] tracking-wider uppercase px-6 py-4 rounded-md text-center hover:bg-primary-dark transition-colors">
                    View Catalogue
                </a>
                <a id="catalogue-viewer-download-alt" download
                    class="flex-1 border border-primary text-primary font-bold text-[12px] tracking-wider uppercase px-6 py-4 rounded-md text-center hover:bg-primary hover:text-white transition-colors">
                    Download
                </a>
            </div>
        </div>
    </div>
</div>`);
        if (window.lucide) window.lucide.createIcons();

        const el = document.getElementById('catalogue-viewer');
        const frame = document.getElementById('catalogue-viewer-frame');
        const fallback = document.getElementById('catalogue-viewer-fallback');
        const close = () => {
            el.classList.add('hidden');
            el.classList.remove('flex');
            frame.removeAttribute('src');
            document.body.style.overflow = '';
        };
        el.addEventListener('click', (e) => {
            if (e.target === el || e.target.closest('[data-viewer-close]')) close();
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !el.classList.contains('hidden')) close();
        });

        const canEmbedPdf = () => navigator.pdfViewerEnabled === true && window.matchMedia('(min-width: 768px)').matches;

        viewer = {
            open: (id, name) => {
                document.getElementById('catalogue-viewer-title').textContent = name || `${id}.pdf`;
                document.getElementById('catalogue-viewer-download').href = catalogueUrl(id, true);
                document.getElementById('catalogue-viewer-download-alt').href = catalogueUrl(id, true);
                document.getElementById('catalogue-viewer-open').href = catalogueUrl(id);
                const embed = canEmbedPdf();
                frame.classList.toggle('hidden', !embed);
                fallback.classList.toggle('hidden', embed);
                fallback.classList.toggle('flex', !embed);
                if (embed) frame.src = catalogueUrl(id);
                el.classList.remove('hidden');
                el.classList.add('flex');
                document.body.style.overflow = 'hidden';
            },
        };
        return viewer;
    };

    const catalogueTitle = (link) => {
        const card = link.closest('.product-card');
        const title = card && card.querySelector('h4');
        return title ? title.textContent.trim() : '';
    };

    const start = async (link, justVerified = false) => {
        if (!justVerified && !isVerified()) {
            openGate(link);
            return;
        }
        const id = link.dataset.catalogue;
        const result = await checkAccess(id);
        if (result === 'ok') {
            getViewer().open(id, catalogueTitle(link));
        } else if (result === 'locked' && !justVerified) {
            // Access expired or cookie cleared: verify again
            setVerified(false);
            openGate(link);
        } else if (result === 'locked') {
            alert('Your email is verified, but the catalogue was blocked. Please allow cookies for this site and try again.');
        } else {
            alert('Sorry, the catalogue could not be opened right now. Please try again later.');
        }
    };

    document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-catalogue]');
        if (!link) return;
        e.preventDefault();
        start(link);
    });
};


const initIcons = () => {
    if (window.lucide) {
        window.lucide.createIcons();
    }
};


const initSwiper = () => {
    const swiperEl = document.querySelector(".mySwiper");
    if (swiperEl && window.Swiper) {
        new window.Swiper(".mySwiper", {
            slidesPerView: 1.1,
            spaceBetween: 20,
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.2,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                }
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            grabCursor: true,
        });
    }
};


const initHeaderScroll = () => {
    window.addEventListener('scroll', () => {
        const header = document.querySelector('header');
        if (header) {
            if (window.scrollY > 50) {
                header.classList.add('py-2');
                header.classList.remove('py-4');
            } else {
                header.classList.add('py-4');
                header.classList.remove('py-2');
            }
        }
    });
};


const initMobileMenu = () => {
    const toggleBtn = document.getElementById('mobile-menu-toggle');
    const closeBtn = document.getElementById('mobile-menu-close');
    const menu = document.getElementById('mobile-menu');
    const menuLinks = document.querySelectorAll('#mobile-menu a');
    const mobileProductsToggle = document.getElementById('mobile-products-toggle');
    const mobileProductsMenu = document.getElementById('mobile-products-menu');

    // Handle mobile menu open/close
    if (toggleBtn && menu) {
        toggleBtn.addEventListener('click', () => {
            menu.classList.remove('translate-x-full');
            document.body.style.overflow = 'hidden';
        });
    }

    if (closeBtn && menu) {
        closeBtn.addEventListener('click', () => {
            menu.classList.add('translate-x-full');
            document.body.style.overflow = '';
        });
    }

    // Close menu when any link is clicked
    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            menu.classList.add('translate-x-full');
            document.body.style.overflow = '';
        });
    });

    // Handle mobile products submenu toggle
    if (mobileProductsToggle && mobileProductsMenu) {
        const productsChevron = mobileProductsToggle.querySelector('[data-lucide="chevron-down"]');
        mobileProductsToggle.addEventListener('click', (e) => {
            e.preventDefault();
            const isHidden = mobileProductsMenu.classList.contains('hidden');
            if (isHidden) {
                mobileProductsMenu.classList.remove('hidden');
                mobileProductsMenu.classList.add('flex');
                if (productsChevron) productsChevron.classList.add('rotate-180');
            } else {
                mobileProductsMenu.classList.remove('flex');
                mobileProductsMenu.classList.add('hidden');
                if (productsChevron) productsChevron.classList.remove('rotate-180');
            }
        });
    }
};

const initTabs = () => {
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabBtns.length === 0 || tabContents.length === 0) return;

    tabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const targetId = btn.id.replace('tab-', 'content-');
            const targetContent = document.getElementById(targetId);
            
            if (!targetContent) return;

            tabBtns.forEach(b => {
                b.classList.remove('border-b-2', 'border-primary', 'text-primary', 'active');
                b.classList.add('text-[#BCC1CF]');
            });

            btn.classList.remove('text-[#BCC1CF]');
            btn.classList.add('border-b-2', 'border-primary', 'text-primary', 'active');

            tabContents.forEach(content => {
                content.classList.add('hidden');
            });

            targetContent.classList.remove('hidden');
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initPageTransitions();
        initCatalogueDownloads();
        initIcons();
        initSwiper();
        initHeaderScroll();
        initMobileMenu();
        initTabs();
    });
} else {
    initPageTransitions();
    initCatalogueDownloads();
    initIcons();
    initSwiper();
    initHeaderScroll();
    initMobileMenu();
    initTabs();
}

document.addEventListener('DOMContentLoaded', () => {
    const contactForm = document.getElementById('contactForm');

    if (contactForm) {
        contactForm.addEventListener('submit', (event) => {
            event.preventDefault();

            const formData = {
                name: event.target.name.value,
                email: event.target.email.value,
                message: event.target.message.value,
            };

            // Retrieve existing submissions from local storage
            const submissions = JSON.parse(localStorage.getItem('contactSubmissions')) || [];

            // Add new submission
            submissions.push(formData);

            // Save back to local storage
            localStorage.setItem('contactSubmissions', JSON.stringify(submissions));

            alert('Thank you for your message!');

            // Reset the form
            contactForm.reset();
        });
    }
});


